export class AtivoParamModel {
    contratoId: number;
    descricao: string;
}
